module.exports = __webpack_public_path__ + "img/s1-0.d5f662fd.svg";